var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(-832.031 -71.891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m870.954 87.9h-36.923s2.145 36.133 25.959 36.133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.259 78.928a5.037 5.037 0 1 1 5.037 5.038 5.037 5.037 0 0 1 -5.037-5.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.434 93.029-2.414 6.138 2.54 8.122 2.013-8.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m865.734 87.9 2.7 5.13 2.55-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880.087 88v-.1h-23.132v.074a18.859 18.859 0 0 0 .086 26.551l2.862-2.861c-5.427-5.427-5.743-11.843-.957-17.647l1.075 21.329v23.278h3.5l3.359-23.278h3.252l3.359 23.278h3.5v-23.28h.035l1.045-21.22c4.8 5.805 4.491 12.123-.941 17.555l2.862 2.862a18.858 18.858 0 0 0 .095-26.541z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.021 109.83v28.792h3.5l3.359-23.278h3.252l3.359 23.278h3.5v-23.278h.035v-5.514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853.371 93.075c-9.035 3.3-20 5.245-19.309-5.176h30.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.6 93.029-2.414 6.138 2.54 8.122 2.013-8.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.225 87.9 2.361 4.809 2.231-4.809z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.a538509de68cfefaf340f246a1a22786.svg";
export { ForwardRef as ReactComponent };